<script setup lang="ts">
import { WEB_APP_URL } from '~/constants/website'

useDefaultMeta({
  title: 'Aplikasi Kirim Paket COD Terbaik #1 Indonesia | KiriminAja',
  description:
    'Kirim paket ke seluruh Indonesia dengan pengiriman reguler KiriminAja! Ekspedisi terlengkap, bisa COD, &amp; tanpa minimum jumlah kiriman. Kirim sekarang!'
})

const faqs = [
  {
    question: 'Apa itu jasa pengiriman instant?',
    answer:
      '<p>Pengiriman Instant adalah layanan pengiriman super cepat dengan estimasi waktu 2-4 jam setelah paket diambil oleh kurir. Paket dikirim langsung ke penerima tanpa transit, sehingga sangat cocok untuk kebutuhan mendesak atau pengiriman barang penting.</p>'
  },
  {
    question: 'Berapa lama waktu pengiriman paket instant?',
    answer:
      '<p>Pengiriman instant menjamin paket tiba di tujuan dalam waktu maksimal 2-4 jam, bahkan bisa hanya dalam 30 menit untuk jarak dekat. Layanan ini cocok untuk pengiriman cepat di wilayah yang sama atau dalam kota.</p>'
  },
  {
    question: 'Apa bedanya pengiriman same day dengan instant?',
    answer:
      '<p>Same Day: paket dijemput dan dikirim pada hari yang sama dengan durasi hingga beberapa jam.<br />Instant: Lebih cepat dari same day, dengan waktu pengiriman hanya 2-4 jam atau kurang, langsung setelah dijemput kurir. Pengiriman instant cocok untuk kebutuhan yang memprioritaskan kecepatan tinggi.</p>'
  }
]
</script>

<template>
  <div class="flex flex-col">
    <HeroBase
      title="Kirim Paket Instant, Lebih Cepat Sampai Tujuan"
      sub-title="Pengiriman Instant untuk Bisnismu"
      description="Kirim paket lebih cepat untuk pelanggan yang butuh produkmu dalam hitungan jam."
      hero-image="/images/batch-2/instant-welcome.webp"
      button-label="Kirim Paket Sekarang"
      :button-link="$utm.utmUrl(WEB_APP_URL)"
    />
    <LayananInstanBenefit />
    <LayananInstanKirimPaketCepat />
    <LayananInstanCaraKirimPaket />
    <LayananInstanExpedition />
    <LayananPilihanLayanan />
    <FaqBase :faqs="faqs" />
    <CtaSection />
  </div>
</template>
